@if (searchService.search_loading || loadingHotels) {
  <app-loading-screen icon="ico-rail">
    <span title i18n="@@wellbeingloading_title">Just loading your search results</span>
    <div msgOne>
      <span i18n="@@wellbeingloading_msgOne">Loading rail and hotel results...</span>
    </div>
    <span msgTwo i18n="wellbeingloading_msgTwo">Checking for availability</span>
  </app-loading-screen>
}
@if (
  {
    cheapest: searchParamsRail.cheapest | async,
    isLoading: (searchParamsRail.isLoading | async),
    jitRulesReceived: (searchParamsHotel.jitRulesReceived | async)
  };
  as data
) {
  <div class="background-container-background">
    <app-risk-alerts [countryCode]="'GB'" [wellBeing]="true"></app-risk-alerts>
  </div>
  @if (!data.isLoading) {
    <div>
      <div style="margin-bottom: 2rem; margin-top: 2rem">
        <div class="title">
          <h3>Recommended Rail Result</h3>
          <a id="view-all-rail-results" (click)="navigateTo(ServiceType.Rail)" class="view_all_link"
            >View All Rail Results</a
          >
        </div>
        @if (
          data.cheapest.outboundCheapest.dualSingleJourneyFares.price ||
          data.cheapest.outboundCheapest.returnJourneyFares.price
        ) {
          <app-wellbeing-chosen-rail
            [outboundCheapest]="data.cheapest.outboundCheapest"
            [inboundCheapest]="data.cheapest.inboundCheapest"
          ></app-wellbeing-chosen-rail>
        }
        @if (
          !data.cheapest.outboundCheapest.dualSingleJourneyFares.price &&
          !data.cheapest.outboundCheapest.returnJourneyFares.price
        ) {
          <p class="error">No Rail Found!</p>
        }
      </div>
      <div>
        <div class="title">
          <h3>Recommended Hotel Result</h3>
          <a
            id="view-all-hotel-results"
            (click)="navigateTo(ServiceType.Hotel)"
            class="view_all_link"
            >View All Hotel Results</a
          >
        </div>
        <!-- MAP VIEW-->
        @if (hotelViewController.showMap) {
          @if (hotelViewController.single) {
            <div class="hotel-map-results">
              <app-map-hotels
                [noOfRooms]="noOfRooms"
                (afterBackToList)="hotelViewController.showMap = false"
                [arrayOfHotels]="this.hotelViewController.hotelChosen"
                [mapControl]="hotelViewController"
              >
              </app-map-hotels>
            </div>
          }
          @if (!hotelViewController.single) {
            <div class="hotel-map-results">
              <app-map-hotels
                [noOfRooms]="noOfRooms"
                (afterBackToList)="hotelViewController.showMap = false"
                [arrayOfHotels]="data.results"
                [mapControl]="hotelViewController"
              >
              </app-map-hotels>
            </div>
          }
        }
        @if (cheapestHotel && !hotelViewController.showMap) {
          <app-item-hotels
            [hotelDetail]="cheapestHotel"
            [jitRulesReceived]="data.jitRulesReceived"
            [rooms]="cheapestHotelAvailability"
            [noOfRooms]="searchParamsHotel.tempParams.no_of_rooms"
            [index]="0"
          >
          </app-item-hotels>
        }
        @if (!cheapestHotel) {
          <p class="error">No Hotel Found!</p>
        }
      </div>
    </div>
  }
}
